import { useRef, useLayoutEffect, useCallback } from 'react';

export default function useSafeDispatch(dispatch) {
  const mountedRef = useRef(false);

  useLayoutEffect(() => {
    mountedRef.current = true;
    return () => (mountedRef.current = false);
  }, []);

  return useCallback(
    (...args) => {
      if (!mountedRef.current) {
        return;
      }
      return dispatch(...args);
    },
    [dispatch]
  );
}
